import * as Map from './maps/map.js';

Map.loader.load().then(() => {
    /* == THE MAP == */
    let map = new google.maps.Map(document.getElementById("map"), {
        center: {
            lat: Map.defaultMapCenterLocation.lat,
            lng: Map.defaultMapCenterLocation.lng
        },
        zoom: Map.defaultMapCenterLocation.zoom,
        mapId: Map.defaultMapCenterLocation.mapId,
        streetViewControl: false,
        mapTypeControl: false
    });

    // let markers = [];

    const icon = {
        url: themeRoot+'/assets/img/map-pin.svg',
        scaledSize: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(0,0)
    }

    let markerParams = {
        icon: icon,
        animation: google.maps.Animation.DROP,
        position: {
            lat: Map.defaultMapCenterLocation.lat,
            lng: Map.defaultMapCenterLocation.lng,
        },
        map: map
    }

    new google.maps.Marker( markerParams );

    window.setTimeout(function(){
        for (var i = document.getElementsByClassName('gm-style-cc').length - 1; i >= 0; i--) {
            if((i == 0) && document.getElementsByClassName('gm-style-cc')[i]){
                document.getElementsByClassName('gm-style-cc')[i].remove();
            }
        };

    }, 2000);
});